import { IUser } from 'app/shared/model/user.model';

export interface IUserExtra {
  id?: number;
  title?: string | null;
  title2?: string | null;
  position?: string | null;
  note?: string | null;
  signatureContentType?: string | null;
  signature?: string | null;
  user?: IUser | null;
}

export const defaultValue: Readonly<IUserExtra> = {};
